<template>
    <!-- StartOF パスワードを再設定する -->
        <div class="bg">
             <div class="center-content">
                 <!-- 会社のロゴ -->
                 <img src="@/assets/site_img/logo.png" alt="logo photo" class="logo">
                 <!-- ログインフォーム -->
                 <form class="form col-md-9 col-lg-10 col-xl-12" @submit.prevent="reset_password_data()">
                    <div v-if="alertVisible" class="alert alert-warning">
                        {{ alertMessage }}
                    </div>
                    <div class="form-input">
                        <input type="text" v-model="userData.uid" class="form-control input-text" disabled style="color: black">
                        <span class="icon"><i class="bi bi-person" style="color: black"></i></span>
                    </div>
                    <div class="form-input">
                        <input type="password" v-model="userData.newPassword" placeholder="NEW PASSWORD"
                        class="form-control input-text" @focus="newPasswordFocus = true" @blur="newPasswordFocus = false"  autocomplete="new-password"  :minlength="5" :maxlength="10" required>
                        <span class="icon"><i class="bi bi-lock"  :style="{ color: newPasswordFocus ? 'black' : 'white' }"></i></span>
                    </div>
                    <div class="form-input">
                        <input type="password" v-model="userData.confirmPassword" placeholder="Confirm NEW PASSWORD" class="form-control input-text" @focus="confirmPasswordFocus = true" @blur="confirmPasswordFocus = false"  autocomplete="confirm-password" :minlength="5"    :maxlength="10" required>
                        <span class="icon"><i class="bi bi-lock"  :style="{ color: confirmPasswordFocus ? 'black' : 'white' }"></i></span>
                    </div>
                    <div class="form-input mt-4">
                        <button class="btn btn-lg btn-light w-100 fs-5 reset-btn">Change Password</button>
                    </div>
                    <router-link to="/applicantList" class="text-decoration-none text-white">
                        <span class="forgot-text">Back to Home</span>
                    </router-link>
                 </form>
             </div>
        </div>
     <!-- EndOF パスワードを再設定する -->
</template>
<style lang="css" scoped src="@/assets/css/login.css"></style>
<script>
import Configuration from "../Service/configuration.js";
import DataService from "../Service/data-service.js";
import Swal from "sweetalert2";
import { swal_option } from "@/Util/swal-option.js";
import { msg_code } from "@/Util/msg_code.js";
import timeoutMixin from '@/Util/timeoutMixin.js';
import { mapState } from 'vuex';
var dataService = new DataService();
var config = new Configuration();
export default {
  mixins: [timeoutMixin],
    data() {
         return {
            userData: {
                uid: "",
                newPassword: "",
                confirmPassword: "",
            },
            userList: [],
            inputFocus: false,
            newPasswordFocus: false,
            confirmPasswordFocus: false,
            alertVisible: false,
            alertMessage: "",
         };
    },
    computed: {
        ...mapState(['userID']),
    },
    async mounted() {
        this.userData.uid = this.userID;
    },
    methods: {
        async reset_password_data() {
            var userData = {
                uid: this.userData.uid,
                newPassword: this.userData.newPassword,
                confirmPassword: this.userData.confirmPassword,
            };
            if (userData.newPassword !== userData.confirmPassword) {
                this.alertVisible = true;
                this.alertMessage = msg_code("wf011");
                return;
            }
            var response;
            // ID でパスワードを変更する
            response = await dataService.retrieveWithGet(config.SERVICE_NAME_USER + "/" + userData.uid);
            if (response.success === true) {
                if (response.data.status == 1 || response.data.del_flg == 1){
                    this.alertVisible = true;
                    this.alertMessage = msg_code("wf013");
                    return;
                }
                else {
                    this.changePassword();
                }
            }
            else{
                this.alertVisible = true;
                this.alertMessage = response.message;
                return;
            }
        },
        // パスワード更新機能
        async changePassword() {
            if (this.$store.state.userID !== this.userData.uid) {
                this.alertVisible = true;
                this.alertMessage = msg_code("wf016");
                this.userData = {
                    uid: "",
                    newPassword: "",
                    confirmPassword: ""
                };
                return;
            }
            var serverResponse = await dataService.updateWithPut(config.SERVICE_NAME_CHANGE_PASSWORD,this.userData);
            if(serverResponse.success == true && serverResponse.error == false){
                Swal.fire(swal_option("success", serverResponse.message));
                this.userList = serverResponse.data;
                this.userData = {
                    uid: this.userID,
                    newPassword: null,
                    confirmPassword: null,
                    };
                    this.alertVisible = false;
            }
            else if (serverResponse.success == false && serverResponse.error == false){
                Swal.fire(swal_option("warn", serverResponse.message));
            }
            else{
                Swal.fire(swal_option("error", serverResponse.message));
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('setSessionExpiredMessage', '');
        next();
    },
 };
 </script>